// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { BaseResponseVoid } from '../../../types';

export interface PutDataByIdAgentQuery {
    /** agentNo */
    agentNo: string;
}

export interface PutDataByIdAgentParam {
    /** id */
    id: number;
}

/**
 * 修改受理客服
 *
 * @export
 * @tags 通对话管理
 * @link [PUT] /data/{id}/agent
 * @param id
 */
export function putDataByIdAgent(
    options: ApiOptions<PutDataByIdAgentParam, PutDataByIdAgentQuery> & {
        segments: PutDataByIdAgentParam;
        params: PutDataByIdAgentQuery;
    }
): Promise<BaseResponseVoid> {
    return request<never, PutDataByIdAgentParam, PutDataByIdAgentQuery>('/data/{id}/agent', {
        ...options,
        method: 'put',
        __$requestCalleeName: 'putDataByIdAgent',
    });
}

export const meta = [{ tags: ['通对话管理'], path: '/data/{id}/agent', method: 'put' }];
